import { Service } from "./types";

export const services: Service[] = [
  { id: "product-design", label: "Product Design" },
  { id: "ui-ux-design", label: "UI/UX Design" },
  { id: "brand-identity", label: "Brand Identity" },
  { id: "ai-driven", label: "AI-Driven Solutions" },
  { id: "ios-android", label: "iOS & Android Apps" },
  { id: "web-development", label: "Web Development" },
];
